import * as React from "react";
import {cx} from "emotion";

import "./template-card.scss";

import {cs}       from "@Common/react/chain-services";
import {UseState} from "@Common/react/use-state";

export const TemplateCard = ({label, onChangeTemplate=undefined, img, comment, maxCommentLength=100}) => cs(
    () => (
        <div className="template-card-3ff">
            <div className="header">
                <div className="left">
                    <div className="label">
                        {label}
                    </div>
                    {onChangeTemplate && (
                        <div className="actions">
                            <a
                                onClick={onChangeTemplate}
                            >
                                Change Template
                            </a>
                        </div>
                    )}
                </div>

                <img
                    src={img}
                />
            </div>

            <div className="comments">
                <div className="label">
                    <div className="text">
                        Comments
                    </div>

                </div>
                {cs(
                    ["text", (_, next) => next(comment)],
                    ["needCollapsing", ({text}, next) => next(text?.length > maxCommentLength)],
                    ["collapsed", (_, next) => UseState({initValue: true, next})],
                    ({collapsed, needCollapsing, text}) => (
                        <div className={cx("content", {collapsed: needCollapsing && collapsed.value})}>
                            <div className="text">
                                {!needCollapsing || !collapsed.value ? (
                                    text
                                ) : (
                                    text.substring(0, maxCommentLength - 3) + "…"
                                )}
                            </div>
                            {needCollapsing && (
                                <a
                                    className="expansion-control"
                                    onClick={() => collapsed.change(v=>!v)}
                                >
                                    {collapsed.value ? (
                                        "+ More"
                                    ) : (
                                        "- Less"
                                    )}
                                </a>
                            )}
                        </div>
                    )
                )}
            </div>
        </div>
    ),
);
